module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp23_8017.799c8b5a.png";